




































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { NumberUtils } from '@/utils/number.utils';

@Component({
  name: 'GStudentRecordTrendScoreTransition',
  computed: {},
  methods: {},
})
export default class GStudentRecordTrendScoreTransition extends mixins(GPageBase) {
  @Prop() beforeScore: number;
  @Prop() afterScore: number;
  @Prop() isCompetencyScoreLess: boolean;
  @Prop() isHumanitiesOrSciences: boolean; // 文理傾向かどうか

  toAbsoluteValue(value: number): number {
    return NumberUtils.toAbsoluteValue(value);
  }

  humanitiesOrSciences(value: number): string {
    if (value < 0) return this.$t('HUMANITIES').toString();
    if (value > 0) return this.$t('SCIENCES').toString();
    return '';
  }
}
